import styled from 'styled-components';
import { colors } from "../../utils/colors";

export const FooterInfo = styled.div`
    width: 100%;
    background-color: gainsboro;
    padding: 25px 60px;
    position: relative;

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 20px 0 0 0;
        text-align: center;
    }
`;

export const FooterContactWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #1b2c58;

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 20px 0 0 0;
        text-align: center;
        align-items: center;
        margin-bottom: 20px;
    }
`;

export const FooterImageWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 45vw;
    
    @media (min-width: 1800px) {
        width: 40vw;
    }
    
    @media (min-width: 2000px) {
        width: 30vw;
    }

    @media (max-width: 1200px) {
        position: relative;
        width: 100vw;
        height: 400px;
    }
`;

export const FormTitle = styled.h1`
    font-family: 'Courgette', cursive;
    margin-bottom: 20px;
    color: ${colors.BLUE};

    @media (max-width: 1200px) {
        color: ${colors.WHITE};
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    background: white;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    
    div{
        position: relative;
        margin: 5px 15px;
            input{
                border: none;
                background: inherit;
                border-bottom: 2px solid ${colors.CREAM};
                width: 100%;
                height: 24px;
                margin-bottom: 15px;
                color: ${colors.CREAM};
            }
            label {
                color: ${colors.BLUE};
                position: absolute;
                top: -2px;
                left: 10px;
                z-index: 10;
            }
            textarea{
                width: 100%;
                border: none;
                background: inherit;
                border-bottom: 2px solid ${colors.CREAM};
                margin-bottom: 5px;
                color: ${colors.CREAM};
            }
            textarea:focus + label,
            input:focus + label{
                transform: translateY(-22px);
                transition: .3s ease-in;
            }
            textarea:valid + label,
            input:valid + label {
                transform: translateY(-22px);
            }
        }
        button{
            background-color: ${colors.BLUE};
            color: ${colors.WHITE};
            font-family: 'Dancing Script', cursive;
            border: none;
            padding: 5px 0;
            border-radius: 5px;
            margin-left: 15px;
            -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            transition: .3s ease-in;
            max-width: 200px;
            &:hover{
                cursor: pointer;
                transform: translateY(-2px);
                transition: .3s ease-in;
            }

            @media (max-width: 1200px) {
                margin: 0 auto !important;
                width: 300px;
            }
        }
        
    @media (max-width: 1200px) {
        margin-bottom: 50px;
    }
`;

export const FullFormWrapper = styled.div`
    width: 500px;
    position: absolute;
    bottom: -15px;
    left: -300px;

    @media (max-width: 1200px) {
        width: auto;
        left: 20px;
        right: 20px;
        bottom: -10px;
    }
`;